export default "__VITE_ASSET__Bjkr9wnW__"